export enum Tab {
  DailyBonus = '1',
  CouponArea = '2',
}
